export const insightsWithoutGroupingColumnState = [
  {
    colId: 'callCount',
    hide: false,
    aggFunc: 'count',
  },
  {
    colId: 'liveCallCount',
    hide: false,
    aggFunc: 'count',
  },
  {
    colId: 'completedCalls',
    hide: false,
    aggFunc: 'count',
  },
  {
    colId: 'endedCalls',
    hide: false,
    aggFunc: 'count',
  },
  {
    colId: 'connectedCallCount',
    hide: false,
    aggFunc: 'count',
  },
  {
    colId: 'payoutCount',
    hide: false,
    aggFunc: 'count',
  },
  {
    colId: 'convertedCalls',
    hide: false,
    aggFunc: 'count',
  },
  {
    colId: 'nonConnectedCallCount',
    hide: false,
    aggFunc: 'count',
  },
  {
    colId: 'duplicateCalls',
    hide: false,
    aggFunc: 'count',
  },
  {
    colId: 'blockedCalls',
    hide: false,
    aggFunc: 'count',
  },
  {
    colId: 'incompleteCalls',
    hide: false,
    aggFunc: 'count',
  },
  {
    colId: 'payoutPerCall',
    hide: false,
    aggFunc: 'avg',
  },
  {
    colId: 'earningsPerCallGross',
    hide: false,
    aggFunc: 'avg',
  },
  {
    colId: 'buyerInsightsConversionAmount',
    hide: false,
    aggFunc: 'sum',
  },
  {
    colId: 'conversionAmount',
    hide: false,
    aggFunc: 'sum',
  },
  {
    colId: 'payoutAmount',
    hide: false,
    aggFunc: 'sum',
  },
  {
    colId: 'profitGross',
    hide: false,
    aggFunc: 'sum',
  },
  {
    colId: 'profitMarginGross',
    hide: false,
    aggFunc: 'percent',
  },
  {
    colId: 'convertedPercent',
    hide: false,
    aggFunc: 'percent',
  },
  {
    colId: 'callLengthInSeconds',
    hide: false,
    aggFunc: 'sum',
  },
  {
    colId: 'avgHandleTime',
    hide: false,
    aggFunc: 'avg',
  },
  {
    colId: 'totalCost',
    hide: false,
    aggFunc: 'sum',
  },
];

export const customColumnStatesMapping = {
  telcoCost: {
    hide: false,
    aggFunc: 'sum'
  },
  icpCost: {
    hide: false,
    aggFunc: 'sum'
  },
  dataEnrichmentCount: {
    hide: false,
    aggFunc: 'sum'
  },
  transcriptionCount: {
    hide: false,
    aggFunc: 'sum'
  },
  transcriptionCost: {
    hide: false,
    aggFunc: 'sum'
  },
  profitNet: {
    hide: false,
    aggFunc: 'sum'
  },
  totalCost: {
    hide: false,
    aggFunc: 'sum'
  },
  earningsPerCallNet: {
    hide: false,
    aggFunc: 'avg'
  },
  profitMarginNet: {
    hide: false,
    aggFunc: 'percent',
    width: 100
  },
  payoutCount: {
    hide: false,
    aggFunc: 'count'
  },
  nonConnectedPercent: {
    hide: false,
    aggFunc: 'percent',
    width: 120
  },
  blockedPercent: {
    hide: false,
    aggFunc: 'percent'
  },
  convAdjustmentRequestCount: {
    hide: false,
    aggFunc: 'sum',
    width: 160
  },
  convAdjustmentsApproved: {
    hide: false,
    aggFunc: 'sum',
    width: 160
  },
  convAdjustmentsRejectedCount: {
    hide: false,
    aggFunc: 'sum',
    width: 160
  },
  payoutAdjustedCalls: {
    hide: false,
    aggFunc: 'count',
    width: 160
  },
  conversionAdjustedCalls: {
    hide: false,
    aggFunc: 'count',
    width: 160
  },
  convAdjustmentsApprovedAmount: {
    hide: false,
    aggFunc: 'sum',
    width: 160
  },
  connectedCallLengthInSeconds: {
    hide: false,
    aggFunc: 'sum',
    width: 155
  }
};

export const defaultInsightColDefs = [
  {
    id: 'campaignName',
    roles: ['admin', 'user'],
    title: 'Campaign',
    type: 'keyword',
    isTag: false,
    groupName: 'Popular',
    filterGroupName: 'Name/ID',
    supportsFilter: true,
    supportsGrouping: true,
    supportsPivot: false,
    supportsSorting: true,
    isComputed: false,
    isAggregate: false
  },
  {
    id: 'publisherName',
    roles: ['admin', 'user'],
    title: 'Publisher',
    type: 'keyword',
    isTag: false,
    groupName: 'Popular',
    filterGroupName: 'Name/ID',
    supportsFilter: true,
    supportsGrouping: true,
    supportsPivot: false,
    supportsSorting: true,
    isComputed: false,
    isAggregate: false
  },
  {
    id: 'publisherSubId',
    roles: ['admin', 'user'],
    title: 'Publisher Sub ID',
    type: 'keyword',
    isTag: false,
    groupName: 'Popular',
    filterGroupName: 'Name/ID',
    supportsFilter: true,
    supportsGrouping: true,
    supportsPivot: false,
    supportsSorting: true,
    isComputed: false,
    isAggregate: false
  },
  {
    id: 'targetName',
    roles: ['admin', 'user'],
    title: 'Target',
    type: 'keyword',
    isTag: false,
    groupName: 'Popular',
    filterGroupName: 'Name/ID',
    supportsFilter: true,
    supportsGrouping: true,
    supportsPivot: false,
    supportsSorting: true,
    isComputed: false,
    isAggregate: false
  },
  {
    id: 'buyer',
    roles: ['admin', 'user'],
    title: 'Buyer',
    type: 'keyword',
    isTag: false,
    groupName: 'Popular',
    filterGroupName: 'Name/ID',
    supportsFilter: true,
    supportsGrouping: true,
    supportsPivot: false,
    supportsSorting: true,
    isComputed: false,
    isAggregate: false
  },
  {
    id: 'targetGroupName',
    roles: ['admin', 'user'],
    title: 'Target Group',
    type: 'keyword',
    isTag: false,
    groupName: 'Popular',
    filterGroupName: 'Name/ID',
    supportsFilter: true,
    supportsGrouping: true,
    supportsPivot: false,
    supportsSorting: true,
    isComputed: false,
    isAggregate: false
  },
  {
    id: 'timeToCallInSeconds',
    roles: ['admin', 'user'],
    title: 'Time To Call',
    type: 'timespan',
    isTag: false,
    groupName: 'Time',
    filterGroupName: 'Time',
    supportsFilter: true,
    supportsGrouping: false,
    supportsPivot: false,
    supportsSorting: true,
    isComputed: false,
    isAggregate: true,
    aggregateTypes: ['Sum', 'Avg', 'Min', 'Max']
  },
  {
    id: 'callLengthInSeconds',
    roles: ['admin', 'user'],
    title: 'Call Length',
    type: 'timespan',
    isTag: false,
    groupName: 'Time',
    filterGroupName: 'Time',
    supportsFilter: true,
    supportsGrouping: false,
    supportsPivot: false,
    supportsSorting: true,
    isComputed: false,
    isAggregate: true,
    aggregateTypes: ['Sum', 'Avg', 'Min', 'Max'],
  },
  {
    id: 'avgHandleTime',
    roles: ['admin', 'user'],
    title: 'ACL',
    type: 'timespan',
    isTag: false,
    groupName: 'Time',
    filterGroupName: 'Time',
    supportsFilter: true,
    supportsGrouping: false,
    supportsPivot: false,
    supportsSorting: true,
    isComputed: false,
    isAggregate: true,
    aggregateTypes: ['Avg'],
  },
  {
    id: 'connectedCallLengthInSeconds',
    roles: ['admin', 'user'],
    title: 'Connected Call Length',
    type: 'timespan',
    isTag: false,
    groupName: 'Time',
    filterGroupName: 'Time',
    supportsFilter: true,
    supportsGrouping: false,
    supportsPivot: false,
    supportsSorting: true,
    isComputed: false,
    isAggregate: true,
    aggregateTypes: ['Sum', 'Avg', 'Min', 'Max']
  },
  {
    id: 'callCount',
    roles: ['admin', 'user'],
    title: 'Calls',
    type: 'long',
    isTag: false,
    groupName: 'Call',
    filterGroupName: 'Call',
    supportsFilter: false,
    supportsGrouping: false,
    supportsPivot: false,
    supportsSorting: true,
    isComputed: false,
    isAggregate: true,
    aggregateTypes: ['Count'],
  },
  {
    id: 'liveCallCount',
    roles: ['admin', 'user'],
    title: 'Live',
    type: 'long',
    isTag: false,
    groupName: 'Call',
    filterGroupName: 'Call',
    supportsFilter: false,
    supportsGrouping: false,
    supportsPivot: false,
    supportsSorting: true,
    isComputed: false,
    isAggregate: true,
    aggregateTypes: ['Count']
  },
  {
    id: 'nonConnectedCallCount',
    roles: ['admin', 'user'],
    title: 'No Connect',
    type: 'long',
    isTag: false,
    groupName: 'Call',
    filterGroupName: 'Call',
    supportsFilter: false,
    supportsGrouping: false,
    supportsPivot: false,
    supportsSorting: true,
    isComputed: false,
    isAggregate: true,
    aggregateTypes: ['Count'],
  },
  {
    id: 'connectedCallCount',
    roles: ['admin', 'user'],
    title: 'Connected',
    type: 'long',
    isTag: false,
    groupName: 'Call',
    filterGroupName: 'Call',
    supportsFilter: false,
    supportsGrouping: false,
    supportsPivot: false,
    supportsSorting: true,
    isComputed: false,
    isAggregate: true,
    aggregateTypes: ['Count'],
  },
  {
    id: 'payoutCount',
    roles: ['admin', 'user'],
    title: 'Paid',
    type: 'long',
    isTag: false,
    groupName: 'Performance',
    filterGroupName: 'Performance',
    supportsFilter: false,
    supportsGrouping: false,
    supportsPivot: false,
    supportsSorting: true,
    isComputed: false,
    isAggregate: true,
    aggregateTypes: ['Count']
  },
  {
    id: 'conversionAdjustedCalls',
    roles: ['admin', 'user'],
    title: 'Conversion-Adjusted Calls',
    type: 'long',
    isTag: false,
    groupName: 'Adjustment',
    filterGroupName: 'Adjustment',
    supportsFilter: false,
    supportsGrouping: false,
    supportsPivot: false,
    supportsSorting: true,
    isComputed: false,
    isAggregate: true,
    aggregateTypes: ['Count']
  },
  {
    id: 'payoutAdjustedCalls',
    roles: ['admin', 'user'],
    title: 'Payout-Adjusted Calls',
    type: 'long',
    isTag: false,
    groupName: 'Adjustment',
    filterGroupName: 'Adjustment',
    supportsFilter: false,
    supportsGrouping: false,
    supportsPivot: false,
    supportsSorting: true,
    isComputed: false,
    isAggregate: true,
    aggregateTypes: ['Count']
  },
  {
    id: 'duplicateCalls',
    roles: ['admin', 'user'],
    title: 'Duplicate',
    type: 'long',
    isTag: false,
    groupName: 'Performance',
    filterGroupName: 'Performance',
    supportsFilter: false,
    supportsGrouping: false,
    supportsPivot: false,
    supportsSorting: true,
    isComputed: false,
    isAggregate: true,
    aggregateTypes: ['Count'],
  },
  {
    id: 'completedCalls',
    roles: ['admin', 'user'],
    title: 'Completed',
    type: 'long',
    isTag: false,
    groupName: 'Call',
    filterGroupName: 'Call',
    supportsFilter: false,
    supportsGrouping: false,
    supportsPivot: false,
    supportsSorting: true,
    isComputed: false,
    isAggregate: true,
    aggregateTypes: ['Count'],
  },
  {
    id: 'endedCalls',
    roles: ['admin', 'user'],
    title: 'Ended Calls',
    type: 'long',
    isTag: false,
    groupName: 'Call',
    filterGroupName: 'Call',
    supportsFilter: false,
    supportsGrouping: false,
    supportsPivot: false,
    supportsSorting: true,
    isComputed: false,
    isAggregate: true,
    aggregateTypes: ['Count'],
  },
  {
    id: 'incompleteCalls',
    roles: ['admin', 'user'],
    title: 'IVR Hangup',
    type: 'long',
    isTag: false,
    groupName: 'Call',
    filterGroupName: 'Call',
    supportsFilter: false,
    supportsGrouping: false,
    supportsPivot: false,
    supportsSorting: true,
    isComputed: false,
    isAggregate: true,
    aggregateTypes: ['Count'],
  },
  {
    id: 'convertedCalls',
    roles: ['admin', 'user'],
    title: 'Converted',
    type: 'long',
    isTag: false,
    groupName: 'Performance',
    filterGroupName: 'Performance',
    supportsFilter: false,
    supportsGrouping: false,
    supportsPivot: false,
    supportsSorting: true,
    isComputed: false,
    isAggregate: true,
    aggregateTypes: ['Count'],
  },
  {
    id: 'blockedCalls',
    roles: ['admin', 'user'],
    title: 'Blocked',
    type: 'long',
    isTag: false,
    groupName: 'Performance',
    filterGroupName: 'Performance',
    supportsFilter: false,
    supportsGrouping: false,
    supportsPivot: false,
    supportsSorting: true,
    isComputed: false,
    isAggregate: true,
    aggregateTypes: ['Count'],
  },
  {
    id: 'dataEnrichmentCount',
    roles: ['admin', 'user'],
    title: 'ICP Count',
    type: 'long',
    isTag: false,
    groupName: 'ICP',
    filterGroupName: 'ICP',
    supportsFilter: true,
    supportsGrouping: false,
    supportsPivot: false,
    supportsSorting: true,
    isComputed: false,
    isAggregate: true,
    aggregateTypes: ['Sum', 'Avg', 'Min', 'Max']
  },
  {
    id: 'ivrDepth',
    roles: ['admin', 'user'],
    title: 'IVR Depth',
    type: 'long',
    isTag: false,
    groupName: 'IVR',
    filterGroupName: 'IVR',
    supportsFilter: true,
    supportsGrouping: false,
    supportsPivot: false,
    supportsSorting: true,
    isComputed: false,
    isAggregate: true,
    aggregateTypes: ['Sum', 'Avg', 'Min', 'Max']
  },
  {
    id: 'convAdjustmentsRejectedCount',
    roles: ['admin', 'user'],
    title: 'Rejected Adjustments',
    type: 'long',
    isTag: false,
    groupName: 'Adjustment',
    filterGroupName: 'Adjustment',
    supportsFilter: true,
    supportsGrouping: false,
    supportsPivot: false,
    supportsSorting: true,
    isComputed: false,
    isAggregate: true,
    aggregateTypes: ['Sum', 'Avg', 'Min', 'Max']
  },
  {
    id: 'convAdjustmentRequestCount',
    roles: ['admin', 'user'],
    title: 'Requested Adjustments',
    type: 'long',
    isTag: false,
    groupName: 'Adjustment',
    filterGroupName: 'Adjustment',
    supportsFilter: true,
    supportsGrouping: false,
    supportsPivot: false,
    supportsSorting: true,
    isComputed: false,
    isAggregate: true,
    aggregateTypes: ['Sum', 'Avg', 'Min', 'Max']
  },
  {
    id: 'convAdjustmentsApproved',
    roles: ['admin', 'user'],
    title: 'Approved Adjustments',
    type: 'long',
    isTag: false,
    groupName: 'Adjustment',
    filterGroupName: 'Adjustment',
    supportsFilter: true,
    supportsGrouping: false,
    supportsPivot: false,
    supportsSorting: true,
    isComputed: false,
    isAggregate: true,
    aggregateTypes: ['Sum', 'Avg', 'Min', 'Max']
  },
  {
    id: 'convAdjustmentsApprovedAmount',
    roles: ['admin', 'user'],
    title: 'Approved Adjustment',
    type: 'double',
    isTag: false,
    groupName: 'Performance',
    filterGroupName: 'Performance',
    supportsFilter: true,
    supportsGrouping: false,
    supportsPivot: false,
    supportsSorting: true,
    isComputed: false,
    isAggregate: true,
    aggregateTypes: ['Sum', 'Avg', 'Min', 'Max']
  },
  {
    id: 'conversionAmount',
    roles: ['admin', 'user'],
    title: 'Revenue',
    type: 'money',
    isTag: false,
    groupName: 'Performance',
    filterGroupName: 'Performance',
    supportsFilter: true,
    supportsGrouping: false,
    supportsPivot: false,
    supportsSorting: true,
    isComputed: false,
    isAggregate: true,
    aggregateTypes: ['Sum', 'Avg', 'Min', 'Max'],
  },
  {
    id: 'profitNet',
    roles: ['admin', 'user'],
    title: 'Profit Net Telco',
    type: 'money',
    isTag: false,
    groupName: 'Performance',
    filterGroupName: 'Performance',
    supportsFilter: true,
    supportsGrouping: false,
    supportsPivot: false,
    supportsSorting: true,
    isComputed: false,
    isAggregate: true,
    aggregateTypes: ['Sum', 'Avg', 'Min', 'Max']
  },
  {
    id: 'profitGross',
    roles: ['admin', 'user'],
    title: 'Profit',
    type: 'money',
    isTag: false,
    groupName: 'Performance',
    filterGroupName: 'Performance',
    supportsFilter: true,
    supportsGrouping: false,
    supportsPivot: false,
    supportsSorting: true,
    isComputed: false,
    isAggregate: true,
    aggregateTypes: ['Sum', 'Avg', 'Min', 'Max'],
  },
  {
    id: 'payoutAmount',
    roles: ['admin', 'user'],
    title: 'Payout',
    type: 'money',
    isTag: false,
    groupName: 'Performance',
    filterGroupName: 'Performance',
    supportsFilter: true,
    supportsGrouping: false,
    supportsPivot: false,
    supportsSorting: true,
    isComputed: false,
    isAggregate: true,
    aggregateTypes: ['Sum', 'Avg', 'Min', 'Max'],
  },
  {
    id: 'totalCost',
    roles: ['admin', 'user'],
    title: 'Total Cost',
    type: 'money',
    isTag: false,
    groupName: 'Performance',
    filterGroupName: 'Performance',
    supportsFilter: true,
    supportsGrouping: false,
    supportsPivot: false,
    supportsSorting: true,
    isComputed: false,
    isAggregate: true,
    aggregateTypes: ['Sum', 'Avg', 'Min', 'Max']
  },
  {
    id: 'telcoCost',
    roles: ['admin', 'user'],
    title: 'Telco Cost',
    type: 'money',
    isTag: false,
    groupName: 'Performance',
    filterGroupName: 'Performance',
    supportsFilter: true,
    supportsGrouping: false,
    supportsPivot: false,
    supportsSorting: true,
    isComputed: false,
    isAggregate: true,
    aggregateTypes: ['Sum', 'Avg', 'Min', 'Max']
  },
  {
    id: 'icpCost',
    roles: ['admin', 'user'],
    title: 'ICP Cost',
    type: 'money',
    isTag: false,
    groupName: 'ICP',
    filterGroupName: 'ICP',
    supportsFilter: true,
    supportsGrouping: false,
    supportsPivot: false,
    supportsSorting: true,
    isComputed: false,
    isAggregate: true,
    aggregateTypes: ['Sum', 'Avg', 'Min', 'Max']
  },
  {
    id: 'blockedPercent',
    roles: ['admin', 'user'],
    title: 'Blocked %',
    type: 'percent',
    isTag: false,
    groupName: 'Performance',
    filterGroupName: 'Performance',
    supportsFilter: false,
    supportsGrouping: false,
    supportsPivot: false,
    supportsSorting: true,
    isComputed: true,
    isAggregate: true,
    aggregateTypes: ['Percent']
  },
  {
    id: 'convertedPercent',
    roles: ['admin', 'user'],
    title: 'CR%',
    type: 'percent',
    isTag: false,
    groupName: 'Performance',
    filterGroupName: 'Performance',
    supportsFilter: false,
    supportsGrouping: false,
    supportsPivot: false,
    supportsSorting: true,
    isComputed: true,
    isAggregate: true,
    aggregateTypes: ['Percent'],
  },
  {
    id: 'nonConnectedPercent',
    roles: ['admin', 'user'],
    title: 'No Answer %',
    type: 'percent',
    isTag: false,
    groupName: 'Performance',
    filterGroupName: 'Performance',
    supportsFilter: false,
    supportsGrouping: false,
    supportsPivot: false,
    supportsSorting: true,
    isComputed: true,
    isAggregate: true,
    aggregateTypes: ['Percent']
  },
  {
    id: 'earningsPerCallGross',
    roles: ['admin', 'user'],
    title: 'RPC',
    type: 'money',
    isTag: false,
    groupName: 'Performance',
    filterGroupName: 'Performance',
    supportsFilter: false,
    supportsGrouping: false,
    supportsPivot: false,
    supportsSorting: true,
    isComputed: true,
    isAggregate: true,
    aggregateTypes: ['Avg'],
  },
  {
    id: 'earningsPerCallNet',
    roles: ['admin', 'user'],
    title: 'RPC Net',
    type: 'money',
    isTag: false,
    groupName: 'Performance',
    filterGroupName: 'Performance',
    supportsFilter: false,
    supportsGrouping: false,
    supportsPivot: false,
    supportsSorting: true,
    isComputed: true,
    isAggregate: true,
    aggregateTypes: ['Avg']
  },
  {
    id: 'profitMarginGross',
    roles: ['admin', 'user'],
    title: 'Margin',
    type: 'percent',
    isTag: false,
    groupName: 'Performance',
    filterGroupName: 'Performance',
    supportsFilter: false,
    supportsGrouping: false,
    supportsPivot: false,
    supportsSorting: true,
    isComputed: true,
    isAggregate: true,
    aggregateTypes: ['Percent'],
  },
  {
    id: 'profitMarginNet',
    roles: ['admin', 'user'],
    title: 'Net Margin',
    type: 'percent',
    isTag: false,
    groupName: 'Performance',
    filterGroupName: 'Performance',
    supportsFilter: false,
    supportsGrouping: false,
    supportsPivot: false,
    supportsSorting: true,
    isComputed: true,
    isAggregate: true,
    aggregateTypes: ['Percent'],
  }
];

export default [
  {
    colId: 'ag-Grid-AutoColumn',
    hide: false,
    minWidth: 250,
    flex: 2,
    pinned: 'left',
  },
  ...insightsWithoutGroupingColumnState
];